import React from 'react';
import { Link } from 'react-router-dom';
import { Anchor, ArrowRight, Phone, Mail } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center">
                <Anchor className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold">{companyInfo.name}</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Spécialiste du nettoyage de coques de bateaux par drone sous-marin sur les lacs de Suisse romande.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-slate-400">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-sm">Lac de Neuchâtel :</span>
                <a href="tel:0265520622" className="text-blue-400 hover:text-blue-300 text-sm">026 552 06 22</a>
              </div>
              <div className="flex items-center gap-2 text-slate-400">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-sm">Lac de Morat :</span>
                <a href="tel:0265520620" className="text-blue-400 hover:text-blue-300 text-sm">026 552 06 20</a>
              </div>
              <div className="flex items-center gap-2 text-slate-400">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-sm">Lac Léman :</span>
                <a href="tel:0215521020" className="text-blue-400 hover:text-blue-300 text-sm">021 552 10 20</a>
              </div>
              <div className="flex items-center gap-2 text-slate-400 mt-4">
                <Mail className="w-4 h-4 text-blue-400" />
                <a href="mailto:info@desinfection.ch" className="text-blue-400 hover:text-blue-300 text-sm">info@desinfection.ch</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Navigation</h3>
            <ul className="space-y-3">
              {[
                { name: 'Accueil', path: '/' },
                { name: 'Notre Robot', path: '/keelcrab' },
                { name: 'À propos', path: '/about' },
                { name: 'Contact', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-slate-400 hover:text-blue-400 transition-colors flex items-center gap-2"
                  >
                    <ArrowRight className="w-4 h-4" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empty column for balance */}
          <div></div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. Tous droits réservés.
          </p>
          <p className="text-slate-500 text-sm">
            Fournisseur officiel Keelcrab en Suisse romande
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
